import { render, staticRenderFns } from "./ClientMultiCreate.vue?vue&type=template&id=08da4324&scoped=true&"
import script from "./ClientMultiCreate.vue?vue&type=script&lang=js&"
export * from "./ClientMultiCreate.vue?vue&type=script&lang=js&"
import style0 from "./ClientMultiCreate.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08da4324",
  null
  
)

export default component.exports